export default __webpack_public_path__ + "static/media/mock-up.3df96287.svg";